export const LIST_REQUISITES = [
  "icons",
  "bankName",
  "active",
  "bik",
  "companyName",
  "correspondentAccount",
  "email",
  "fax",
  "fullCompanyName",
  "inn",
  "kpp",
  "legalAddress",
  "ogrn",
  "ogrn_date",
  "ogrn_number",
  "okved",
  "paymentAccount",
  "phone",
  "postalAddress",
];
